import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getPageMetadata } from '@/config/pageMetadata'

/**
 * Sets document.title and meta name="description" from page metadata for the current route.
 * Call inside a component that is rendered under a RouterProvider.
 */
export function usePageMetadata(): void {
  const { pathname } = useLocation()
  const { title, description } = getPageMetadata(pathname)

  useLayoutEffect(() => {
    document.title = title

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', 'description')
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', description)
  }, [title, description])
}
